import React, { useState } from 'react';
import {
  CattleNvdWrapper,
  FormSection,
  CheckboxGroup,
  CheckboxItem,
  ButtonsWrapper,
  FormButton,
  DeclarationText,
  FormHeader,
  FormTitle,
  TwoColumns,
  FormField,
  CattleTable,
  TableWrapper,
  QuestionGroup,
  QuestionLabel,
  RadioGroup,
  DeclarationContainer,
  OutlineButton,
  FormTopHeader,
  // ProgressIndicator,
} from './cattleNvd.style';

const CattleNvd = () => {
  const [currentStep, setCurrentStep] = useState(0);
  const [formData, setFormData] = useState({
    // NVD Number
    nvdNumber: '',

    // Owner/cattle details
    fullTradingName: '',
    propertyAddress: '',
    propertyTown: '',
    propertyState: '',
    propertyPostcode: '',
    propertyPIC: '',

    // Cattle description
    cattleDescription: [{ number: '', description: '', brands: '' }],

    // Consignment details
    consignedTo: '',
    destinationAddress: '',
    destinationState: '',
    destinationPIC: '',

    // NLIS devices
    nlisDevices: '',
    nlisRumenDevices: '',

    // Part A Questions
    hormonalGrowthPromotant: '', // Yes/No
    animalFats: '', // Yes/No
    ownershipSinceBirth: '', // Yes/No
    byProductStockfeeds: '', // Yes/No

    // Part A - Chemical residue questions (5-9)
    chemicalResidues6Months: '', // Yes/No
    withholdingPeriod: '', // Yes/No
    materialConsumed60Days: '', // Yes/No
    sprayRiskArea42Days: '', // Yes/No
    additionalInfo: '',

    // Declaration
    declarantName: '',
    declarantAddress: '',
    phone: '',
    fax: '',
    email: '',
    signature: '',
    date: '',

    // Part B - Transport details
    movementCommenced: '',
    vehicleRegistration: '',
    transporterName: '',
    transporterSignature: '',
    transporterDate: '',
    transporterTelNo: '',
  });

  const steps = [
    'NVD & Owner Details',
    'Cattle Description',
    'Consignment Details',
    'Part A - Questions 1-4',
    'Part A - Questions 5-9',
    'Declaration',
    'Part B - Transport',
  ];

  const handleInputChange = (field, value) => {
    setFormData((prev) => ({
      ...prev,
      [field]: value,
    }));
  };

  const handleCattleDescriptionChange = (index, field, value) => {
    const newCattleDescription = [...formData.cattleDescription];
    newCattleDescription[index] = {
      ...newCattleDescription[index],
      [field]: value,
    };
    setFormData((prev) => ({
      ...prev,
      cattleDescription: newCattleDescription,
    }));
  };

  const addCattleRow = () => {
    setFormData((prev) => ({
      ...prev,
      cattleDescription: [...prev.cattleDescription, { number: '', description: '', brands: '' }],
    }));
  };

  const removeCattleRow = (index) => {
    if (formData.cattleDescription.length > 1) {
      setFormData((prev) => ({
        ...prev,
        cattleDescription: prev.cattleDescription.filter((_, i) => i !== index),
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    console.log('NVD Form Data:', formData);
    // Handle form submission here
    alert('NVD Form submitted successfully!');
  };

  const nextStep = () => {
    if (currentStep < steps.length - 1) {
      setCurrentStep((prev) => prev + 1);
    }
  };

  const prevStep = () => {
    if (currentStep > 0) {
      setCurrentStep((prev) => prev - 1);
    }
  };

  const renderStep = () => {
    switch (currentStep) {
      case 0:
        return (
          <FormSection>
            <FormField>
              <label>NVD No:</label>
              <input
                type="text"
                name="nvd-number"
                value={formData.nvdNumber}
                onChange={(e) => handleInputChange('nvdNumber', e.target.value)}
                placeholder="Enter NVD Number"
                required
              />
            </FormField>

            <FormSection className="part-a-section">
              <h3 className="section-title">Part A - Owner Details</h3>
              <p className="section-subtitle">
                To be completed by the owner or person responsible for the husbandry of the cattle
              </p>

              <div className="subsection">
                <h4 className="subsection-title">Owner of cattle</h4>
                <FormField>
                  <label>Full Trading Name *</label>
                  <input
                    type="text"
                    name="full-trading-name"
                    value={formData.fullTradingName}
                    onChange={(e) => handleInputChange('fullTradingName', e.target.value)}
                    placeholder="Enter full trading name"
                    required
                  />
                </FormField>
              </div>

              <div className="subsection">
                <h4 className="subsection-title">Property/place where the journey commenced</h4>
                <TwoColumns>
                  <FormField>
                    <label>Address *</label>
                    <input
                      type="text"
                      name="property-address"
                      value={formData.propertyAddress}
                      onChange={(e) => handleInputChange('propertyAddress', e.target.value)}
                      placeholder="Enter property address"
                      required
                    />
                  </FormField>
                  <FormField>
                    <label>Town/Suburb *</label>
                    <input
                      type="text"
                      name="property-town"
                      value={formData.propertyTown}
                      onChange={(e) => handleInputChange('propertyTown', e.target.value)}
                      placeholder="Enter town/suburb"
                      required
                    />
                  </FormField>
                  <FormField>
                    <label>State *</label>
                    <select
                      name="property-state"
                      value={formData.propertyState}
                      onChange={(e) => handleInputChange('propertyState', e.target.value)}
                      required
                    >
                      <option value="">Select State</option>
                      <option value="NSW">NSW</option>
                      <option value="VIC">VIC</option>
                      <option value="QLD">QLD</option>
                      <option value="WA">WA</option>
                      <option value="SA">SA</option>
                      <option value="TAS">TAS</option>
                      <option value="NT">NT</option>
                      <option value="ACT">ACT</option>
                    </select>
                  </FormField>
                  <FormField>
                    <label>Postcode</label>
                    <input
                      type="text"
                      name="property-postcode"
                      value={formData.propertyPostcode}
                      onChange={(e) => handleInputChange('propertyPostcode', e.target.value)}
                      placeholder="Enter postcode"
                    />
                  </FormField>
                </TwoColumns>
                <FormField>
                  <label>Property Identification Code (PIC) of this property *</label>
                  <input
                    type="text"
                    name="property-pic"
                    value={formData.propertyPIC}
                    onChange={(e) => handleInputChange('propertyPIC', e.target.value)}
                    placeholder="Enter Property Identification Code"
                    required
                  />
                </FormField>
              </div>
            </FormSection>
          </FormSection>
        );

      case 1:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Description of cattle</h3>
            </FormHeader>

            <TableWrapper>
              <CattleTable>
                <thead>
                  <tr>
                    <th>Number</th>
                    <th>Description (CLASS, SEX, AGE, BREED)</th>
                    <th>Brands or Earmarks</th>
                    <th>Action</th>
                  </tr>
                </thead>
                <tbody>
                  {formData.cattleDescription.map((row, index) => (
                    <tr key={index}>
                      <td>
                        <input
                          type="number"
                          value={row.number}
                          onChange={(e) =>
                            handleCattleDescriptionChange(index, 'number', e.target.value)
                          }
                          placeholder="Qty"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.description}
                          onChange={(e) =>
                            handleCattleDescriptionChange(index, 'description', e.target.value)
                          }
                          placeholder="e.g., Hereford Cross Steers, 2 years"
                        />
                      </td>
                      <td>
                        <input
                          type="text"
                          value={row.brands}
                          onChange={(e) =>
                            handleCattleDescriptionChange(index, 'brands', e.target.value)
                          }
                          placeholder="Brands/Earmarks"
                        />
                      </td>
                      <td>
                        <FormButton
                          type="button"
                          onClick={() => removeCattleRow(index)}
                          className="remove-btn"
                          disabled={formData.cattleDescription.length === 1}
                        >
                          Remove
                        </FormButton>
                      </td>
                    </tr>
                  ))}
                </tbody>
              </CattleTable>
            </TableWrapper>

            <FormButton type="button" onClick={addCattleRow}>
              + Add Row
            </FormButton>
          </FormSection>
        );

      case 2:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Consignment Details</h3>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Consigned to *</label>
                <input
                  type="text"
                  name="consigned-to"
                  value={formData.consignedTo}
                  onChange={(e) => handleInputChange('consignedTo', e.target.value)}
                  placeholder="Enter consignee name"
                  required
                />
              </FormField>
              <FormField>
                <label>Destination State *</label>
                <select
                  name="destination-state"
                  value={formData.destinationState}
                  onChange={(e) => handleInputChange('destinationState', e.target.value)}
                  required
                >
                  <option value="">Select State</option>
                  <option value="NSW">NSW</option>
                  <option value="VIC">VIC</option>
                  <option value="QLD">QLD</option>
                  <option value="WA">WA</option>
                  <option value="SA">SA</option>
                  <option value="TAS">TAS</option>
                  <option value="NT">NT</option>
                  <option value="ACT">ACT</option>
                </select>
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Destination Address *</label>
              <input
                type="text"
                name="destination-address"
                value={formData.destinationAddress}
                onChange={(e) => handleInputChange('destinationAddress', e.target.value)}
                placeholder="Enter destination address"
                required
              />
            </FormField>

            <TwoColumns>
              <FormField>
                <label>Destination PIC (REQ: WA & TAS)</label>
                <input
                  type="text"
                  name="destination-pic"
                  value={formData.destinationPIC}
                  onChange={(e) => handleInputChange('destinationPIC', e.target.value)}
                  placeholder="Enter destination PIC"
                />
              </FormField>
              <div></div>
            </TwoColumns>

            <div className="subsection">
              <h4 className="subsection-title">NLIS Device Information</h4>
              <TwoColumns>
                <FormField>
                  <label>NLIS devices used (Number of ear tags)</label>
                  <input
                    type="number"
                    name="nlis-devices"
                    value={formData.nlisDevices}
                    onChange={(e) => handleInputChange('nlisDevices', e.target.value)}
                    placeholder="Enter number of ear tags"
                  />
                </FormField>
                <FormField>
                  <label>Number of rumen devices</label>
                  <input
                    type="number"
                    name="nlis-rumen-devices"
                    value={formData.nlisRumenDevices}
                    onChange={(e) => handleInputChange('nlisRumenDevices', e.target.value)}
                    placeholder="Enter number of rumen devices"
                  />
                </FormField>
              </TwoColumns>
            </div>
          </FormSection>
        );

      case 3:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part A - Questions 1-4</h3>
            </FormHeader>

            <QuestionGroup>
              <QuestionLabel>
                1. Have any of the cattle in this consignment ever in their lives been treated with
                a hormonal growth promotant (HGP)? (Use a second document for mixed consignments.)
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="hgp"
                    value="yes"
                    checked={formData.hormonalGrowthPromotant === 'yes'}
                    onChange={(e) => handleInputChange('hormonalGrowthPromotant', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="hgp"
                    value="no"
                    checked={formData.hormonalGrowthPromotant === 'no'}
                    onChange={(e) => handleInputChange('hormonalGrowthPromotant', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                2. Have the cattle in this consignment ever in their lives been fed containing
                animal fats?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="animal-fats"
                    value="yes"
                    checked={formData.animalFats === 'yes'}
                    onChange={(e) => handleInputChange('animalFats', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="animal-fats"
                    value="no"
                    checked={formData.animalFats === 'no'}
                    onChange={(e) => handleInputChange('animalFats', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                3. Has the owner stated above owned these cattle since their birth?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="ownership-birth"
                    value="yes"
                    checked={formData.ownershipSinceBirth === 'yes'}
                    onChange={(e) => handleInputChange('ownershipSinceBirth', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="ownership-birth"
                    value="no"
                    checked={formData.ownershipSinceBirth === 'no'}
                    onChange={(e) => handleInputChange('ownershipSinceBirth', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                4. In the past 60 days, have any of these cattle been fed by-product stockfeeds?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="by-product-stockfeeds"
                    value="yes"
                    checked={formData.byProductStockfeeds === 'yes'}
                    onChange={(e) => handleInputChange('byProductStockfeeds', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="by-product-stockfeeds"
                    value="no"
                    checked={formData.byProductStockfeeds === 'no'}
                    onChange={(e) => handleInputChange('byProductStockfeeds', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
            </QuestionGroup>
          </FormSection>
        );

      case 4:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part A - Questions 5-9 (Chemical Residue Questions)</h3>
            </FormHeader>

            <QuestionGroup>
              <QuestionLabel>
                5. In the past 6 months have any of these animals been on a property listed on the
                ERP database or placed under any restrictions because of chemical residues?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="chemical-residues-6months"
                    value="yes"
                    checked={formData.chemicalResidues6Months === 'yes'}
                    onChange={(e) => handleInputChange('chemicalResidues6Months', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="chemical-residues-6months"
                    value="no"
                    checked={formData.chemicalResidues6Months === 'no'}
                    onChange={(e) => handleInputChange('chemicalResidues6Months', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                6. Are any of the cattle in this consignment still within a Withholding Period (WHP)
                or Export Slaughter Interval (ESI) as set by APVMA or SAFEMEAT, following treatment
                with any veterinary drug or chemical?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="withholding-period"
                    value="yes"
                    checked={formData.withholdingPeriod === 'yes'}
                    onChange={(e) => handleInputChange('withholdingPeriod', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="withholding-period"
                    value="no"
                    checked={formData.withholdingPeriod === 'no'}
                    onChange={(e) => handleInputChange('withholdingPeriod', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                7. In the past 60 days, have any of the cattle in this consignment consumed any
                material that was still within a withholding period when harvested, collected or
                first grazed?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="material-consumed-60days"
                    value="yes"
                    checked={formData.materialConsumed60Days === 'yes'}
                    onChange={(e) => handleInputChange('materialConsumed60Days', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="material-consumed-60days"
                    value="no"
                    checked={formData.materialConsumed60Days === 'no'}
                    onChange={(e) => handleInputChange('materialConsumed60Days', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
            </QuestionGroup>

            <QuestionGroup>
              <QuestionLabel>
                8. In the past 42 days, were any of these cattle:
                <br />
                a) grazed in a spray risk area; or
                <br />
                b) fed fodders cut from a spray drift risk area?
              </QuestionLabel>
              <RadioGroup>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="spray-risk-area"
                    value="yes"
                    checked={formData.sprayRiskArea42Days === 'yes'}
                    onChange={(e) => handleInputChange('sprayRiskArea42Days', e.target.value)}
                  />
                  <span className="radio-label">Yes</span>
                </label>
                <label className="radio-option">
                  <input
                    type="radio"
                    name="spray-risk-area"
                    value="no"
                    checked={formData.sprayRiskArea42Days === 'no'}
                    onChange={(e) => handleInputChange('sprayRiskArea42Days', e.target.value)}
                  />
                  <span className="radio-label">No</span>
                </label>
              </RadioGroup>
            </QuestionGroup>

            <FormField className="full-width">
              <label>
                9. Please include any additional information below (eg: vaccination programs, animal
                health certification, additional declarations, etc.)
              </label>
              <textarea
                name="additional-info"
                value={formData.additionalInfo}
                onChange={(e) => handleInputChange('additionalInfo', e.target.value)}
                rows={4}
                placeholder="Enter any additional information..."
              />
            </FormField>
          </FormSection>
        );

      case 5:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Declaration</h3>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Full Name *</label>
                <input
                  type="text"
                  name="declarant-name"
                  value={formData.declarantName}
                  onChange={(e) => handleInputChange('declarantName', e.target.value)}
                  placeholder="Enter full name"
                  required
                />
              </FormField>
              <FormField>
                <label>Phone</label>
                <input
                  type="tel"
                  name="phone"
                  value={formData.phone}
                  onChange={(e) => handleInputChange('phone', e.target.value)}
                  placeholder="Enter phone number"
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Full Address *</label>
              <input
                type="text"
                name="declarant-address"
                value={formData.declarantAddress}
                onChange={(e) => handleInputChange('declarantAddress', e.target.value)}
                placeholder="Enter full address"
                required
              />
            </FormField>

            <TwoColumns>
              <FormField>
                <label>Fax</label>
                <input
                  type="tel"
                  name="fax"
                  value={formData.fax}
                  onChange={(e) => handleInputChange('fax', e.target.value)}
                  placeholder="Enter fax number"
                />
              </FormField>
              <FormField>
                <label>Email</label>
                <input
                  type="email"
                  name="email"
                  value={formData.email}
                  onChange={(e) => handleInputChange('email', e.target.value)}
                  placeholder="Enter email address"
                />
              </FormField>
            </TwoColumns>

            <DeclarationContainer>
              <div className="declaration-text">
                <h4>Declaration Statement</h4>
                <p>
                  I declare that, I am the owner or the person responsible for the husbandry of the
                  cattle and that all the information in Part A of this document is true and
                  correct. I also declare that I have read and understood all the questions that I
                  have answered, that I have read and understood the explanatory notes, and that,
                  while under my control, the cattle were not fed restricted animal material
                  (including meat and bone meal) in breach of any State or Territory legislation.
                </p>
              </div>

              <FormField>
                <label>Date *</label>
                <input
                  type="date"
                  name="date"
                  value={formData.date}
                  onChange={(e) => handleInputChange('date', e.target.value)}
                  required
                />
              </FormField>
            </DeclarationContainer>
          </FormSection>
        );

      case 6:
        return (
          <FormSection>
            <FormHeader>
              <h3 className="section-title">Part B - Transport Details</h3>
              <p className="section-subtitle">
                To be completed by the person in charge of the cattle while they are being moved.
                Completion of this part is optional in SA and VIC.
              </p>
            </FormHeader>

            <TwoColumns>
              <FormField>
                <label>Movement commenced (Date/Time)</label>
                <input
                  type="datetime-local"
                  name="movement-commenced"
                  value={formData.movementCommenced}
                  onChange={(e) => handleInputChange('movementCommenced', e.target.value)}
                />
              </FormField>
              <FormField>
                <label>Vehicle registration number(s)</label>
                <input
                  type="text"
                  name="vehicle-registration"
                  value={formData.vehicleRegistration}
                  onChange={(e) => handleInputChange('vehicleRegistration', e.target.value)}
                  placeholder="Enter vehicle registration"
                />
              </FormField>
            </TwoColumns>

            <FormField>
              <label>Transporter Name</label>
              <input
                type="text"
                name="transporter-name"
                value={formData.transporterName}
                onChange={(e) => handleInputChange('transporterName', e.target.value)}
                placeholder="Name of person in charge of cattle during movement"
              />
            </FormField>

            <TwoColumns>
              <FormField>
                <label>Date</label>
                <input
                  type="date"
                  name="transporter-date"
                  value={formData.transporterDate}
                  onChange={(e) => handleInputChange('transporterDate', e.target.value)}
                />
              </FormField>
              <FormField>
                <label>Telephone Number</label>
                <input
                  type="tel"
                  name="transporter-tel"
                  value={formData.transporterTelNo}
                  onChange={(e) => handleInputChange('transporterTelNo', e.target.value)}
                  placeholder="Enter telephone number"
                />
              </FormField>
            </TwoColumns>

            <DeclarationContainer>
              <div className="declaration-text">
                <h4>Transport Declaration</h4>
                <p>
                  I am the person in charge of the cattle during the movement and declare all the
                  information in Part B is true and correct.
                </p>
              </div>
            </DeclarationContainer>
          </FormSection>
        );

      default:
        return null;
    }
  };

  return (
    <CattleNvdWrapper>
      <FormTopHeader>
        <FormTitle>National Vendor Declaration (Cattle) and Waybill</FormTitle>
        <p className="subtitle">
          This form cannot be used where eligibility for the EU market is required.
        </p>
      </FormTopHeader>
      <form onSubmit={handleSubmit}>
        <ButtonsWrapper>
          {currentStep > 0 && (
            <OutlineButton type="button" onClick={prevStep} style={{ maxWidth: 'fit-content' }}>
              ← Back
            </OutlineButton>
          )}

          {currentStep < steps.length - 1 ? (
            <OutlineButton type="button" onClick={nextStep}>
              Next →
            </OutlineButton>
          ) : (
            <OutlineButton type="submit">Submit NVD</OutlineButton>
          )}
        </ButtonsWrapper>
        <div className="form-content">{renderStep()}</div>
      </form>
    </CattleNvdWrapper>
  );
};

export default CattleNvd;
